import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class CompanyType {
  getCompanyType(): string[] {
    return [
      'Altri consorzi',
      'Asili, Scuole, Servizi educativi',
      'Associazione',
      'Circoli',
      'Comitati',
      'Condomini',
      'Consorzio di imprese',
      'Cooperative',
      'Ditta Individuale',
      'Enti Privati',
      'Enti/Istituti',
      'Fondazioni, ordini',
      'Impresa familiare',
      'Mutue',
      'Professionista/Studio Associato',
      'S.a.p.a.',
      'S.a.s.',
      'S.d.f.',
      'S.n.c.',
      'Società cooperative',
      'Società estera con sede in Italia',
      'S.p.a.',
      'S.r.l.',
      'S.r.l.s.',
      'S.s.',
      'Altro'
    ];
  }
}
